import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { workspaceAppearance as workspaceAppearanceApi } from "@/lib/api";
import { applyAppearance, cacheAppearance } from "@/lib/appearance";

export const WORKSPACE_APPEARANCE_QUERY_KEY = ["workspace-appearance"] as const;

export function useWorkspaceAppearance(enabled = true) {
    const query = useQuery({
        queryKey: WORKSPACE_APPEARANCE_QUERY_KEY,
        queryFn: workspaceAppearanceApi.get,
        enabled,
        staleTime: 5 * 60_000,
    });

    useEffect(() => {
        if (!query.data) return;
        applyAppearance(query.data.appearance);
        cacheAppearance(query.data.organizationId, query.data.appearance);
    }, [query.data]);

    return query;
}
